/* eslint-disable Mevl 相关定义 */
const mvelConfig = {
  packageName: 'com.xiaoniu.platform.rule.engine.core.utils.',
  // 调用java代码函数前缀
  funcPrefix: 'MvelFunction.',
  // 规则根据严重级别返回结果函数
  getRuleResult: 'com.xiaoniu.platform.rule.engine.core.utils.MvelFunction.getRuleResult',
  // 不同变量数据类型-条件选择下拉框
  conditionOptions: [
    {label: '==', value: '=='},
    {label: '!=', value: '!='},
    {label: '~=', value: '~='},
    {dataType: 1, label: 'in', value: 'MvelFunction.strInArray'},
    {dataType: 1, label: 'not in', value: 'MvelFunction.strNotInArray'},
    {dataType: 1, label: 'contains', value: 'MvelFunction.contains'},
    {dataType: 1, label: 'not contains', value: 'MvelFunction.notContains'},
    {dataType: 1, label: 'is null', value: 'MvelFunction.isNull'},
    {dataType: 1, label: 'is not null', value: 'MvelFunction.isNotNull'},
    {dataType: 2, label: '>', value: '>'},
    {dataType: 2, label: '>=', value: '>='},
    {dataType: 2, label: '<', value: '<'},
    {dataType: 2, label: '<=', value: '<='}
  ],
  actionOptions: {
    min: 'com.xiaoniu.platform.rule.engine.core.utils.MvelFunction.min',
    max: 'com.xiaoniu.platform.rule.engine.core.utils.MvelFunction.max'
  }
}

const getMvelJavaExpression = function (condition, variableName, expression) {
  return mvelConfig.packageName + condition + '(' + variableName + ',"' + expression + '")'
}

exports.install = function (Vue, options) {
  Vue.prototype.mvelConfig = mvelConfig
  Vue.prototype.getMvelJavaExpression = getMvelJavaExpression
}



// WEBPACK FOOTER //
// ./src/utils/mvel.js